import { createFileRoute } from "@tanstack/react-router"

import ComingSoonPage from "@/features/ComingSoon/ComingSoon";

export const Route = createFileRoute('/coming-soon')({
    component: ComingSoonPage,
});
